/* eslint-disable no-unused-vars */
const ON_CHANGE_DEBOUNCE_TIMER = 300

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityRulesUpdate: 'quantity-rules-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error'
}

const SHOPIFY_PREFIX = {
  product: 'gid://shopify/Product/',
  variant: 'gid://shopify/ProductVariant/',
  sellingPlan: 'gid://shopify/SellingPlan/'
}

const APPSTLE_PROPS = {
  SELECTED_PLAN: '__appstle-selected-selling-plan',
  FULFILLMENT_COUNT: '_appstle_fulfillments-count'
}

const EWG_REPORT_API_URL = 'https://ewgapi.waterdropfilter.com:8443'

// wd event source
const WD_EVENT_SUBSCRIBE_CLICK = 'wd_email_subscribe_click'
const WD_EVENT_SUBSCRIBE_SUCCESS = 'wd_email_subscribe_success'
